export default "<div>\r\n  <img class=\"undermaintenance\" src=\"{{undermaintenanceImage}}\">\r\n</div>"